/* Copyright 2021, Milkdown by Mirone. */
import { TableMap } from 'prosemirror-tables';
export const getCellSelection = (view) => view.state.selection;
export const isFirstRowSelected = (selection) => {
    const map = TableMap.get(selection.$anchorCell.node(-1));
    const start = selection.$anchorCell.start(-1);
    const cells = map.cellsInRect({
        left: 0,
        right: map.width,
        top: 0,
        bottom: 1,
    });
    const selectedCells = map.cellsInRect(map.rectBetween(selection.$anchorCell.pos - start, selection.$headCell.pos - start));
    for (let i = 0, count = cells.length; i < count; i++) {
        if (selectedCells.indexOf(cells[i]) === -1) {
            return false;
        }
    }
    return true;
};
export const calculateItem = (actions, view) => {
    Object.values(actions).forEach((item) => {
        var _a;
        const disable = (_a = item.disable) === null || _a === void 0 ? void 0 : _a.call(item, view);
        if (disable) {
            item.$.classList.add('hide');
            return;
        }
        item.$.classList.remove('hide');
    });
};
//# sourceMappingURL=helper.js.map